import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\laragon\\www\\surilipat-hub\\frontend\\src\\app\\contact-page\\components\\ContactPageInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\laragon\\www\\surilipat-hub\\frontend\\src\\app\\homepage\\components\\Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\laragon\\www\\surilipat-hub\\frontend\\src\\components\\common\\Header.tsx");
